import {
  decideResponseSchema,
  taxonomyResponseSchema,
  type DecideBody,
  type DecideResponse,
  type TaxonomyCode,
} from '@lms/shared-types'
import { apiRequest } from './client'

/**
 * POST /api/v1/leaves/{leaveId}/decide
 *
 * Submits an approve / discuss / hold decision on a leave request.
 * For discuss/hold, `override_reason_code` is required by the backend.
 */
export async function decideLeave(
  leaveId: string,
  body: DecideBody,
): Promise<DecideResponse> {
  const raw = await apiRequest<unknown>(
    `/api/v1/leaves/${encodeURIComponent(leaveId)}/decide`,
    { method: 'POST', body },
  )
  return decideResponseSchema.parse(raw)
}

/**
 * GET /api/v1/override-reason-taxonomy
 *
 * Returns the ordered list of override reason codes used to populate
 * the OverrideReasonSheet radio list.
 */
export async function getOverrideTaxonomy(): Promise<TaxonomyCode[]> {
  const raw = await apiRequest<unknown>('/api/v1/override-reason-taxonomy')
  const parsed = taxonomyResponseSchema.parse(raw)
  return parsed.codes
}
